export const name = "ST_WITHIN";
export const summary = `Checks if one \`GEOGRAPHY\` value contains another \`GEOGRAPHY\` value.`;
export const reference = `
## ST_WITHIN

Checks if one \`GEOGRAPHY\` value contains another \`GEOGRAPHY\` value.

\`\`\`
ST_WITHIN(geography_1, geography_2)
\`\`\`

### Description

Returns \`TRUE\` if no point of \`geography_1\` is outside of \`geography_2\` and the interiors of \`geography_1\` and \`geography_2\` intersect.

Given two geographies \`a\` and \`b\`, \`ST_WITHIN(a, b)\` returns the same result as \`ST_CONTAINS\`\`(b, a)\`. Note the opposite order of arguments.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
